// cycleDetailsSagas.js
import { call, put, takeEvery } from 'redux-saga/effects';
import { saveCycleChangesFailure, saveCycleChangesSuccess } from '../../features/SaveCycleChanges/SaveCycleChangesSlice';
import { apiPython as api } from '../../../service/api';
import URLs from '../../../constants/urls';
import { SAVE_CYCLE_CHANGES } from '../../actions/SaveCycleDetails/SaveCycleChangesTypes';

function* saveCycleChangesSaga(action) {
    try {
        yield api.post(`${URLs.SAVE_CYCLE_CHANGES}`, action.payload);
    yield put(saveCycleChangesSuccess(response.data));
  } catch (error) {
    yield put(saveCycleChangesFailure(error.message));
  }
}

function* watchSaveCycleChanges() {
  yield takeEvery(SAVE_CYCLE_CHANGES, saveCycleChangesSaga);
}

export default watchSaveCycleChanges;
